<div [className]="'tile bg-'+tileColorName"
     [routerLink]="routingService.erzeugungsanlagePath()"
     [queryParams]="{anlagentype: aggregation?.anlagentyp.abkuerzung}"
     queryParamsHandling="merge">
    <div class="tile-container">
        <div class="tile-icon">
            <img [src]="ASSET_URL + '/innogy-icons/Negative/'+tileIconName"/>
        </div>
        <div class="tile-text">
            <h3 data-qa="westnetzId">
                {{aggregation?.anlagentyp.name}}
            </h3>
            <div style="margin-bottom:8px;">
                {{aggregation?.count}} Erzeugungsanlage{{aggregation?.count > 1 ? 'n' : ''}}
            </div>
            <div>
                {{aggregation?.sum | leistungseinheit:leistungseinheit}} (&#8721;)
            </div>
        </div>
    </div>
</div>
